import { useCallback } from 'react';
import { getClientType } from './useClientType';
import { useEnvironment } from './useEnvironment';
import { Platform } from 'react-native';

export type BuildFastenConnectUrlRequest = (fastenOAuthUrl: string) => string;

export type UseBuildFastenConnectUrlReturnValue = {
    buildFastenConnectUrl: BuildFastenConnectUrlRequest;
};

export function useBuildFastenConnectUrl(): UseBuildFastenConnectUrlReturnValue {
    const environment = useEnvironment();

    const buildFastenConnectUrl: BuildFastenConnectUrlRequest = useCallback(
        (fastenOAuthUrl: string) => {
            if (environment === 'loading') return '';

            const baseUrl = {
                dev: 'https://dev.primaryrecord.app/handle-fasten-redirect',
                prod: 'https://www.primaryrecord.app/handle-fasten-redirect',
            };

            const clientType = getClientType();

            let connectUrl = `${baseUrl[environment]}?connectUrl=${encodeURIComponent(
                fastenOAuthUrl,
            )}&sourceClientType=${clientType}`;

            // For local web dev, include the port so the trampoline can bounce back correctly
            if (Platform.OS === 'web' && clientType === 'local-web') {
                const port = window.location.port || '19006';
                connectUrl += `&localPort=${port}`;
            }

            return connectUrl;
        },
        [environment],
    );

    return {
        buildFastenConnectUrl,
    };
}
